import React from "react";
import { Col, Container, Row } from "reactstrap";

const Tc = () => {
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>Tc</Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Tc;
